export default __webpack_public_path__ + "static/media/img03.3f908c28.jpg";